import React, { Component } from 'react'
import MobileActions from '../../actions/MobileActions'

const showBackButton = WrappedComponent =>
  class extends Component {
    componentWillMount () {
      MobileActions.showBackButton()
    }

    componentWillUnmount () {
      MobileActions.hideBackButton()
    }

    render () {
      return <WrappedComponent {...this.props} />
    }
  }

export default showBackButton



// WEBPACK FOOTER //
// ./src/components/showBackButton/index.js